import React from 'react'
// import Calculatorheading from '../../components/calculator/calculatorheading' 
import ViewCalculator from '../../components/calculator/viewcalculator' // Main calculator component

export default function Calculator() {
  return (
    <div className="px-4">
      {/* Header section (currently disabled) */}
      {/* <Calculatorheading /> */}

      {/* Main calculator view */}
      <ViewCalculator />
    </div>
  )
}
